import { axiosInstance } from "../../../helper"
import { church } from "../types"

export function getChurches(params, config) {
	return {
		type: church.GET_CHURCHES,
		payload: new axiosInstance.get("/church", {
			...config,
			params,
		}),
	}
}

export default getChurches
